var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('entrepreneur-edit',{attrs:{"submit-btn-label":_vm.$t('button-create-entrepeneur'),"name":_vm.name,"month":_vm.month,"year":_vm.year,"gender":_vm.gender},on:{"onEntrepreneurSubmit":_vm.createEntrepeneur}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }